import Ad from "./ad";

export default Ad;